
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";
import { Observable } from 'rxjs';
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { PlanDetailsRequest } from '../../domain/requests/plans/plan-details-request';
import { PlanJobDetails } from "../../domain/models/plan-job-details";

@Injectable({ providedIn: 'root' })
export class GetPlanJobDetailsUsecase implements UseCase<BaseRequest<PlanDetailsRequest>, PlanJobDetails> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: BaseRequest<PlanDetailsRequest>): Observable<PlanJobDetails> {
    return this.planRepository.getPlanJobDetails(params);
  }

}